module.exports = __webpack_public_path__ + "static/NightInTheWoods8-023ca3abf0bea4df29409f524dc388f3.webp";